import getMarker from "./getMarker";
import isEmpty from "./isEmpty";
//---------------------------------
// get combatant headline markers
//---------------------------------
export default function getCombatantHeadlineMarkers(props) {
  // console.log("------------------------");
  // console.log("IN getCombatantHeadlineMarkers");
  let markers = [];
  const max_headline_markers = 3; // 0-3 = 4
  //------------------------------
  // loop to max headline markers
  //------------------------------
  for (let i = 0; i <= max_headline_markers; i++) {
    //
    let m = i + 1;
    let headline_marker = "headline_marker" + m;
    let marker;
    //--------------------
    // load actual marker
    //--------------------
    // console.log("getting marker = " + props.row[headline_marker]);
    if (props.row[headline_marker] && !isEmpty(props.row[headline_marker])) {
      marker = getMarker(props.row[headline_marker]);
      // console.log("got marker = " + marker.label);
      //-------------------
      // load empty marker
      //-------------------
    } else {
      // console.log("loading empty marker...")
      marker = getMarker("empty");
    }
    //---------------
    // push to array
    //---------------
    markers.push(marker);
  }
  return markers;
}
